import React from 'react'
import { Form, InputGroup, Row, Col } from 'react-bootstrap'
import { isAreaArticleType } from '../ArticleParse'
import { areaArticleAcceptedFileTypes } from '../../common'
import type { ArticleTypeValue } from '../../common'

type Values = {
  filename?: string
  replaceFile?: boolean
  deleteFile?: boolean
  file?: string
  articleType: ArticleTypeValue
}

type Errors = { file?: string }
type Touched = { file?: boolean }

type Props = {
  values: Values
  errors: Errors
  touched: Touched
  handleChange: React.ChangeEventHandler<HTMLElement>
  handleBlur: React.FocusEventHandler<HTMLElement>
  setFieldValue: (field: string, value: unknown) => void
  handleFileChange: React.ChangeEventHandler<HTMLInputElement>
}

export const AreaArticleFilenameInput = ({
  values,
  errors,
  touched,
  handleChange,
  handleBlur,
  setFieldValue,
  handleFileChange
}: Props) => {
  const acceptedTypes = areaArticleAcceptedFileTypes.join(',')
  if (values?.filename?.length ?? 0 > 0) {
    return (
      <Row className='mb-2'>
        <Form.Group as={Col}>
          <Form.Label column>領域ファイル</Form.Label>
          <Row>
            <Col sm={8}>
              <Form.Control
                name='filename'
                size='sm'
                defaultValue={values.filename}
                readOnly
                hidden={values.replaceFile}
              />
              <InputGroup>
                <Form.Control
                  id='areaFileInput'
                  name='file'
                  size='sm'
                  type='file'
                  accept={acceptedTypes}
                  value={values.file ?? ''}
                  onChange={handleFileChange}
                  onBlur={handleBlur}
                  hidden={!values.replaceFile}
                />
              </InputGroup>
            </Col>
            <Col sm={4}>
              <Col>
                <Form.Check
                  type='switch'
                  id='replaceFileSwitch'
                  label='変更'
                  name='replaceFile'
                  value={String(values.replaceFile ?? false)}
                  checked={values.replaceFile ?? false}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  disabled={values.deleteFile}
                  inline
                />
                <Form.Check
                  type='switch'
                  id='deleteFileSwitch'
                  label='削除'
                  name='deleteFile'
                  value={String(values.deleteFile ?? false)}
                  checked={values.deleteFile ?? false}
                  onChange={(e) => {
                    setFieldValue('replaceFile', false)
                    handleChange(e)
                  }}
                  onBlur={handleBlur}
                  inline
                />
              </Col>
            </Col>
          </Row>
        </Form.Group>
      </Row>
    )
  } else {
    return (
      <Row className='mb-2'>
        <Form.Group as={Col}>
          <Form.Label column>領域ファイル</Form.Label>
          <Col>
            <Form.Control
              id='file'
              type='file'
              name='file'
              accept={acceptedTypes}
              value={values.file}
              onChange={handleFileChange}
              onBlur={(e) => e.preventDefault()}
              disabled={!isAreaArticleType(values.articleType)}
              isInvalid={!!(touched.file && errors.file)}
            />
            <Form.Control.Feedback type='invalid' className='invalid-file'>
              {errors.file}
            </Form.Control.Feedback>
          </Col>
        </Form.Group>
      </Row>
    )
  }
}
